import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';

@Component
export default class CalendarWrapperComponent extends Vue {
    @Prop({ type: Boolean }) public loading: boolean;
}
